import { kebabCase } from "lodash";
import { PAYMENT_SOURCE_TYPE } from "constants/patients";
import { CSSProperties } from "react";
import { InsuranceIcon, PrivatePayIcon, ThirdPartyPayerIcon } from "../icons";

type PaymentSourceIconProps = {
  paymentSource?: number | null;
  style?: CSSProperties;
  className?: string;
};
export default function PaymentSourceIcon({
  paymentSource,
  style,
  className,
}: PaymentSourceIconProps) {
  const styles = { maxWidth: 28, maxHeight: 28, marginRight: 8, ...style };
  const paymentSourceValue = PAYMENT_SOURCE_TYPE.getFromCode(paymentSource);
  const id = kebabCase(paymentSourceValue);

  if (paymentSource === 1)
    return (
      <PrivatePayIcon
        data-testid={`${id}-icon`}
        style={styles}
        className={className}
      />
    );
  if (paymentSource === 2)
    return (
      <InsuranceIcon
        data-testid={`${id}-icon`}
        style={styles}
        className={className}
      />
    );
  if (paymentSource === 3)
    return (
      <ThirdPartyPayerIcon
        data-testid={`${id}-icon`}
        style={styles}
        className={className}
      />
    );
  return <></>;
}
